import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {useTranslation} from 'react-i18next'
import {useState} from 'react'

const LecMenu = () => {
  const {t} = useTranslation()
  const [showMore, setShowMore] = useState(false)

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/lec/my-profile',
      icon: 'fas fa-user',
      bg: 'bg-primary bg-opacity-10',
      iconColor: 'text-primary',
      textColor: 'text-dark',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/lec/my-courses',
      icon: 'fas fa-book-open',
      bg: 'bg-success',
      iconColor: 'text-success',
      textColor: 'text-white',
    },
    {
      title: t('MENU.PUBLICATIONS'),
      to: '/lec/publications-list',
      icon: 'fas fa-book',
      bg: 'bg-warning',
      iconColor: 'text-warning',
      textColor: 'text-white',
    },
    {
      title: t('MEETING.MEETINGS'),
      to: '/lec/meetings',
      icon: 'fas fa-handshake',
      bg: 'bg-danger',
      iconColor: 'text-danger',
      textColor: 'text-white',
    },
    {
      title: t('MENU.REGULATIONS'),
      to: '/lec/regulations',
      icon: 'fas fa-gavel',
      bg: 'bg-info',
      iconColor: 'text-info',
      textColor: 'text-white',
    },
    {
      title: t('LABEL.FEEDBACK'),
      to: '/lec/feedback',
      icon: 'fas fa-comments',
      bg: 'bg-light-primary',
      iconColor: 'text-primary',
      textColor: 'text-dark',
    },
    {
      title: t('LABEL.PEER_EVALUATION'),
      to: '/lec/peer-evaluations',
      icon: 'fas fa-user-friends',
      bg: 'bg-secondary',
      iconColor: 'text-secondary',
      textColor: 'text-white',
    },
    {
      title: t('LABEL.NEWS'),
      to: '/lec/news-list',
      icon: 'fas fa-bullhorn',
      bg: 'bg-dark',
      iconColor: 'text-dark',
      textColor: 'text-white',
    },
    {
      title: t('LABEL.CHAT'),
      to: '/lec/chat-room',
      icon: 'fas fa-comment-dots',
      bg: 'bg-success',
      iconColor: 'text-success',
      textColor: 'text-white',
    },
  ]

  const moreMenus = [
    {
      title: t('LABEL.MY_UMEF'),
      to: '/lec/my-umef',
      icon: 'fas fa-university',
      color: '#7c3aed',
      internal: true,
    },
    {
      title: t('LABEL.UMEF_NEWS'),
      url: 'https://en.swiss-umef.ch/news-universite-geneve-suisse',
      icon: 'fas fa-newspaper',
      color: '#f97316',
    },
    {
      title: t('LABEL.MY_EVENTS'),
      url: 'https://en.swiss-umef.ch/evenements-universite-geneve',
      icon: 'fas fa-calendar-alt',
      color: '#eab308',
    },
  ]

  const renderMenu = (menu: any) => (
    <div className={`compact-menu-item ${menu.bg}`}>
      <div className={`compact-icon bg-white ${menu.iconColor}`}>
        <i className={menu.icon}></i>
      </div>

      <span className={menu.textColor}>{menu.title}</span>
    </div>
  )

  return (
    <div className='modern-compact-menu'>
      {/* MAIN MENU */}
      <div className='menu-container'>
        {menus.map((menu, index) => (
          <MenuItem key={index} to={menu.to} title={renderMenu(menu)} />
        ))}

        {/* MORE BUTTON */}
        <div onClick={() => setShowMore(!showMore)}>
          <div className='compact-menu-item more-button mt-2'>
            <div className='compact-icon more-icon'>
              <i className='fa fa-plus'></i>
            </div>

            <span>{t('LABEL.MORE')}</span>
          </div>
        </div>
      </div>

      {/* MORE MENU */}
      {showMore && (
        <div className='dropdown-panel'>
          {moreMenus.map((menu, index) =>
            menu.internal ? (
              <MenuItem
                key={index}
                to={menu.to}
                title={
                  <div className='dropdown-item'>
                    <div
                      className='dropdown-icon'
                      style={{
                        background: `${menu.color}15`,
                      }}
                    >
                      <i className={menu.icon} style={{color: menu.color}}></i>
                    </div>

                    <span>{menu.title}</span>
                  </div>
                }
              />
            ) : (
              <a
                key={index}
                href={menu.url}
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <div className='dropdown-item'>
                  <div
                    className='dropdown-icon'
                    style={{
                      background: `${menu.color}15`,
                    }}
                  >
                    <i className={menu.icon} style={{color: menu.color}}></i>
                  </div>

                  <span>{menu.title}</span>
                </div>
              </a>
            )
          )}
        </div>
      )}

      {/* STYLES */}
      <style>{`
        .modern-compact-menu {
          width: 100%;
        }

        .menu-container {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .compact-menu-item {
          height: 52px;

          padding: 0 14px;

          border-radius: 16px;

          border: 1px solid rgba(0,0,0,.04);

          display: flex;
          align-items: center;
          gap: 10px;

          cursor: pointer;

          transition: all .2s ease;
        }

        .compact-menu-item:hover {
          transform: translateY(-2px);

          box-shadow: 0 10px 20px rgba(0,0,0,.08);
        }

        .compact-icon {
          width: 34px;
          height: 34px;

          border-radius: 12px;

          display: flex;
          align-items: center;
          justify-content: center;

          flex-shrink: 0;
        }

        .compact-icon i {
          font-size: 14px;
        }

        .compact-menu-item span {
          font-size: 13px;
          font-weight: 700;

          white-space: nowrap;
        }

        .more-button {
          background: linear-gradient(135deg,#111827,#1f2937);
        }

        .more-button span {
          color: white;
        }

        .more-icon {
          background: rgba(255,255,255,.12);
          color: white;
        }

        .dropdown-panel {
          margin-top: 14px;

          background: white;

          border-radius: 20px;

          padding: 14px;

          display: grid;

          grid-template-columns: repeat(auto-fit,minmax(180px,1fr));

          gap: 10px;

          box-shadow: 0 15px 40px rgba(0,0,0,.08);

          border: 1px solid #eef2f7;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 12px;

          padding: 12px;

          border-radius: 14px;

          background: #f8fafc;

          transition: all .2s ease;

          cursor: pointer;
        }

        .dropdown-item:hover {
          background: #eef2ff;

          transform: translateX(3px);
        }

        .dropdown-icon {
          width: 38px;
          height: 38px;

          border-radius: 12px;

          display: flex;
          align-items: center;
          justify-content: center;

          flex-shrink: 0;
        }

        .dropdown-icon i {
          font-size: 15px;
        }

        .dropdown-item span {
          font-size: 13px;
          font-weight: 600;
          color: #1f2937;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .menu-container {
            gap: 8px;
          }

          .compact-menu-item {
            height: 46px;

            padding: 0 10px;

            border-radius: 14px;

            gap: 8px;
          }

          .compact-icon {
            width: 30px;
            height: 30px;
            border-radius: 10px;
          }

          .compact-menu-item span {
            font-size: 11px;
          }

          .dropdown-panel {
            grid-template-columns: 1fr;
          }
        }

        /* SMALL MOBILE */
        @media (max-width: 480px) {
          .menu-container {
            display: grid;

            grid-template-columns: repeat(2,1fr);
          }

          .compact-menu-item {
            width: 100%;
          }
        }
      `}</style>
    </div>
  )
}

export default LecMenu
